import React, {Fragment} from 'react';
import createEditor, {referenceActionData} from '../form/ComponentEditor';
import Box from '../layout/Box';
import FranchiseClearingForm from './forms/FranchiseClearingForm';
import FranchiseClearingList from './lists/FranchiseClearingList';
import classNames from 'classnames';
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";
import {postData} from "../../utils/request";
import Modal from "../layout/Modal";
import Invoice from "./OperationList/Elements/Invoice";
import get from "../../utils/get";
import Payment from "./OperationList/Elements/Payment";
import {LanguageFormat} from "../../utils/formatters";

class FranchiseClearingEditor extends React.Component {

    state = {
        finalizePayment: false
    }

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        const res = await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    finalizePayment = async () => {
        if (this.state.finalizePayment === false) {
            this.setState({finalizePayment: {}});
            return false;
        }
        const values = await referenceActionData(this.props.values, this.props.componentConfig);
        delete values.items;
        await this.props.processAction(async () => {
            const response = await postData({
                action: this.props.componentConfig.componentname + '.finalizePayment',
                data: values
            });
            if (response.success) {
                this.list && this.list.refreshBackground();
                this.form && this.form.refreshBackground();
                this.setState({finalizePayment: false});
            }
            return response;
        });
    }

    getFieldProps = (name) => {
        const props = this.props.getFieldProps(name);
        props.disabled = props.disabled || (this.props.values[this.props.componentConfig.idfield] && Object.keys(this.props.componentConfig.actions || []).find((action) => this.props.values[action]));
        return props;
    }

    getValue = (name) => {
        return get(this.props.values, name, undefined);
    }

    getProps = (name) => {
        let props = {...this.props.getFieldProps(name)};
        props = {...props, ...this.props[name]};
        if (!props.disabled) {
            const disabled = this.props.disabled;//Array.isArray(this.props.disabled) ? this.props.disabled : [this.props.disabled];
            props.disabled = (!Array.isArray(disabled) && disabled) || (Array.isArray(disabled) && disabled.indexOf(name) !== -1);
            if (this.props[name]) {
                props = {
                    ...this.props[name],
                    ...props,
                    disabled: this.props[name].disabled || props.disabled
                };
            }
        }
        return props;
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const actions = Object.keys(this.props.componentConfig.actions || []).map((action, idx) => {
            return <Button
                className="pull-right"
                disabled={this.props.values[action] || !this.props.values[this.props.componentConfig.idfield]}
                key={idx+2}
                onClick={async () => {
                    await this.props.processAction(async () => {
                        const response = await postData({
                            action: this.props.componentConfig.componentname + '.' + action,
                            [this.props.componentConfig.idfield]: this.props.values[this.props.componentConfig.idfield]
                        });
                        if (response.success) {
                            this.list && this.list.refreshBackground();
                            this.form && this.form.refreshBackground();
                        }
                        return response;
                    });
                }}
                color="default"
            >
                <LanguageFormat id={action + "_button"} base="FranchiseClearing" def={action} />
            </Button>
        });
        return <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Franchise elszámolások"
                    footer={[
                        <Button
                            key="0"
                            disabled={this.props.isLoading}
                            color="default"
                            onClick={this.pristineForm}
                        >
                            Új
                        </Button>
                    ]}
                >
                    <FranchiseClearingList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Franchise elszámolás"
                    footer={[
                        <Button
                            key="0"
                            disabled={!this.props.dirty || this.props.isLoading}
                            color="primary"
                            className="pull-right"
                            onClick={this.saveForm}
                        >
                            Mentés
                        </Button>,
                        <Button
                            key="1"
                            disabled={!(this.props.values[this.props.componentConfig.idfield] && parseInt(this.props.values.state || "0") < 1) || this.props.isLoading}
                            color="danger"
                            className="pull-left"
                            onClick={this.props.deleteForm}
                        >
                            Törlés
                        </Button>,
                        ...actions
                    ]}
                >
                    <FranchiseClearingForm
                        {...this.props}
                        getFieldProps={this.getFieldProps}
                    />
                </Editor>
        </Fragment>;
    }
}

export default createEditor({
    componentName: "FranchiseClearing",
    WrappedComponent: FranchiseClearingEditor,
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            data = await referenceActionData(data, componentConfig);
            delete data.items;
            return {action, data, params};
        }
    }
});
